import { render } from "./GallerySection.vue?vue&type=template&id=5ed637c8"
import script from "./GallerySection.vue?vue&type=script&lang=js"
export * from "./GallerySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__